module.exports = __webpack_public_path__ + "media/images/flags/pg-8252e9bfdbcd82ca9c3f90c88bea7d8c.svg";